import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Flightinfo } from '../models/flightModel';
import { Cart } from '../../models/CartModel';
import { Booking } from '../../models/orderModel';
import { Order } from '../../models/orderModel';
import { BookingConfigService } from './booking-config.service';

@Injectable({
  providedIn: 'root'
})
export class ShuttlebussService {
  private hostPath: string;

  constructor(private authHttp: HttpClient, private bookingConfigService: BookingConfigService
  ) {
    this.hostPath = JSON.parse(this.bookingConfigService.getConfig().IDENTITY);
  }

  public getFlights(date: string, type: string): Observable<Flightinfo[]> {
    const model = { site: 'www.shuttlebuss.se', type, date };
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const url = this.hostPath + 'Shuttlebuss/Shuttlebuss.Service/ArrivalDeparture/flightinfo';
    return this.authHttp
      .post<Flightinfo[]>(url, model, { headers })
      .pipe(
        map(result => {
          return result;
        }),
      );
  }

  public addOrder(order: Booking): Observable<Cart> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const url = this.hostPath + 'Shuttlebuss/Shuttlebuss.Service/cart/addorder/';
    return this.authHttp
      .post<Cart>(url, order, { headers })
      .pipe(
        map(result => {
          return result;
        })
      );
  }

  public getOrder(orderId: string): Observable<Order> {
    const URL = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/checkout/getorder/${orderId}`;
    return this.authHttp.get<Order>(URL).pipe(
      map(order => {

        return order;
      }),
    );
  }

  public createCartOrder(orderId: string): Observable<any> {
    const url = `${this.hostPath}Shuttlebuss/Shuttlebuss.Service/checkout/createcartorder/${orderId}`;
    return this.authHttp.get<any>(url).pipe(
      map(paymentReference => {
        return paymentReference;
      }),
    );
  }

}
